// extracted by mini-css-extract-plugin
export default {"wrapper":"SomethingWentWrong_wrapper__iBs58","label":"SomethingWentWrong_label__T0bK5"};